import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Query, withApollo } from 'react-apollo'
import { Select } from 'antd'
// import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const { Option } = Select

const BARANGAY_PUROK = gql`
    query barangayPurok($barangay_uid: String, $searchFilter: SearchParams) {
		barangayPurok(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const Purok = (props) => {
	const { 
		client, barangay_uid,
		onSelectedItem, onChange, ...rest 
	} = props
	const [searchText, setSearchText] = useState('')

	return (
		<Query 
			query={BARANGAY_PUROK}
			variables={{
				barangay_uid,
				searchFilter: { page: 1, pageSize: 50, searchText }
			}}
			fetchPolicy='network-only'
		>
			{({ loading, error, data }) => {
				const purok = _.has(data, 'barangayPurok') ? data.barangayPurok.data : []
				//console.log('purok', purok)
				return (
					<Select { ...rest }
						loading={loading}
						allowClear
						showSearch
						placeholder='Select Purok'
						onSearch={(value) => setSearchText(value)}
						notFoundContent={null}
						showArrow={false}
						filterOption={false}
						onChange={(value) => {
							if (onSelectedItem) {
								const mPurok = _.find(purok, (i) => _.isEqual(i.uid, value))
								onSelectedItem(mPurok)
							}
							onChange(value)
						}}
					>
						{
							purok.map((item, key) => (
								<Option key={key} value={item.uid}>{item.purok_name}</Option>
							))
						}
					</Select>
				)
			}}
		</Query>
	)
}

const composed = compose(
	withApollo
)

export default composed(Purok)